import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaBuilding } from "react-icons/fa";
import API_URL from "../config";
import "./SiteSelector.css";

export default function SiteSelector({ entrepriseId, onSelect }) {
  const [sites, setSites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;

    const fetchSites = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await axios.get(`${API_URL}/api/sites/${entrepriseId}`);
        if (!mounted) return;
        const data = Array.isArray(res?.data) ? res.data : [];
        setSites(data);

        // Si un seul site -> sélection automatique
        if (data.length === 1) {
          onSelect?.(data[0]);
        }
      } catch (err) {
        if (!mounted) return;
        console.error(" Erreur lors du chargement des sites :", err);
        setError("Impossible de récupérer les sites. Vérifiez la connexion");
        setSites([]);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    if (entrepriseId) {
      fetchSites();
    } else {
      setSites([]);
      setLoading(false);
    }

    return () => {
      mounted = false;
    };
  }, [entrepriseId, onSelect]);

  if (loading) {
    return (
      <div className="site-selector-container">
        <p>⏳ Chargement des sites…</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="site-selector-container">
        <p>⚠️ {error}</p>
      </div>
    );
  }

  if (!sites.length) {
    return (
      <div className="site-selector-container">
        <p>⚠️ Aucun site trouvé pour cette entreprise.</p>
      </div>
    );
  }

  return (
    <div className="site-selector-container">
      <h1>🏢 Sélectionnez un site</h1>
      <p className="subtitle">Choisissez l’un des sites pour continuer</p>

      <div className="site-list" role="list">
        {sites.map((s) => (
          <button
            key={s.id}
            className="site-btn"
            onClick={() => onSelect(s)}
            role="listitem"
            aria-label={`Sélectionner le site ${s.nom}`}
          >
            <FaBuilding className="site-icon" />
            <div className="site-text">
              <div className="site-name">{s.nom}</div>
              {s.adresse && <div className="site-address">{s.adresse}</div>}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
